import { Currency } from '@/core/currency/interfaces';

const XCD: Currency = {
    name: 'East Caribbean Dollar',
    demonym: 'East Caribbean',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '951',
    symbol: '$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'XCD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default XCD;
